<template>
    <modal @close="closeFromModal">
        <template #header>
            <h5>{{ restauName }}</h5>
        </template>
        <template #body>
            <service-day-popover
                ref="popover"
                :serviceId="serviceId"
                :date="date"
                @service-full-changed="$emit(`service-full-changed`, $event)"
                @add-resa="$emit(`add-resa`, $event)"
                @restaurant-name="restauName = $event">
            </service-day-popover>
        </template>
        <template #footer>
            <button type="button" class="modal-default-button btn btn-sm btn-secondary btn-circle me-3" @click="closeFromModal()">
                {{ $tl("labels.form.actions.close") }}
            </button>
        </template>
    </modal>
</template>

<script>
import ServiceDayPopover from "../../components/services/ServiceDayPopover.vue";

export default {
    name: "ServiceDayModal",
    components: { ServiceDayPopover },
    props: {
        serviceId: {
            type: Number,
            required: true,
        },
        date: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            restauName: "",
        };
    },
    methods: {
        close() {
            this.$emit("close");
        },
        closeFromModal: function (e) {
            if (e && e.target && !e.target.classList.contains("modal-wrapper")) {
                e.stopPropagation();
            } else {
                this.close();
            }
        },
    },
};
</script>
